import { useEffect, useRef } from "react";
import useDebounce from "./useDebounce";

export default function useDebouncedValue<T>(value: T, delay: number, callback: (newValue: T) => any) {
    const debouncedValue = useDebounce(value, delay);

    useEffect(() => {
        callback(debouncedValue);
    }, [debouncedValue]);

    return debouncedValue;
}